export default __webpack_public_path__ + "static/media/twelve.9323dd50.png";